import { CssBaseline } from '@mui/material';
import { blue, orange } from '@mui/material/colors';
import { createTheme, StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { Amplify } from 'aws-amplify';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import OrderInfoTypeSwitchRoute from './common/OrderInfoTypeSwitchRoute';
import PrivateRoute from './common/privateRoute';
import Forbidden403Page from './pages/error/Forbidden403Page';
import GeoInformationView from './pages/geoInformation/geoInformationView';
import BusinessOrderComplete from './pages/order/BusinessOrderComplete';
import BusinessOrderConfirm from './pages/order/BusinessOrderConfirm';
import BusinessOrderFlightSearchInput from './pages/order/BusinessOrderFlightSearchInput';
import BusinessOrderGoodsAndDestinationInput from './pages/order/BusinessOrderGoodsAndDestinationInput';
import CustomerOrderComplete from './pages/order/CustomerOrderComplete';
import CustomerOrderConfirm from './pages/order/CustomerOrderConfirm';
import CustomerOrderFlightSearchInput from './pages/order/CustomerOrderFlightSearchInput';
import CustomerOrderGoodsAndDestinationInput from './pages/order/CustomerOrderGoodsAndDestinationInput';
import MaritimeOrderComplete from './pages/order/MaritimeOrderComplete';
import MaritimeOrderConfirm from './pages/order/MaritimeOrderConfirm';
import MaritimeOrderContactInput from './pages/order/MaritimeOrderContactInput';
import MaritimeOrderFlightSearchInput from './pages/order/MaritimeOrderFlightSearchInput';
import OrderAuth from './pages/order/OrderAuth';
import OrderView from './pages/order/OrderView';
import RequesterView from './pages/requester/RequesterView';
import { MaritimeOrderGoodsAndDestinationInput } from './pages/order/MaritimeOrderGoodsAndDestinationInput';

/**
* Material UIのテーマを変える
*/
const theme = createTheme(({
  palette: {
    primary: blue,
    secondary: orange,
    background: {
      paper: "#fafafa",
      default: "#EFEFEF",
    },
  },
}));

let neutralMapName = process.env.REACT_APP_AWS_NEUTRAL_MAP_NAME as string
let saterllitemapName = process.env.REACT_APP_AWS_SATELLITE_MAP_NAME as string
// 既存のcognitoの設定
Amplify.configure({
  Auth: {
    identityPoolId: process.env.REACT_APP_AWS_COGNITO_IDENTITY_POOL_ID as string, // REQUIRED - Amazon Cognito Identity Pool ID
    region: process.env.REACT_APP_AWS_REGION, // REQUIRED - Amazon Cognito Region
  },
  geo: {
    AmazonLocationService: {
      maps: {
        items: {
          neutralMapName: {
            // REQUIRED - Amazon Location Service Map resource name
            style: ["VectorHereExplore"] // REQUIRED - String representing the style of map resource
          },
          saterlltemapName: {
            style: ["RasterHereExploreSatellite"]
          }
        },
        neutral: neutralMapName, // REQUIRED - Amazon Location Service Map resource name to set as default
        satellite: saterllitemapName
      },
      region: process.env.REACT_APP_AWS_REGION, // REQUIRED - Amazon Location Service Region
    },
  }
});

const App = (props: any) => {
  return (
    <BrowserRouter>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route path="/*" element={<PrivateRoute />}>
              <Route
                path=':urlId'
                element={
                  <OrderInfoTypeSwitchRoute
                    business={<BusinessOrderFlightSearchInput />}
                    customer={<CustomerOrderFlightSearchInput />}
                    maritime={<MaritimeOrderFlightSearchInput />}
                  />
                }
              />
              <Route
                path='orderflightsearchinput/:urlId'
                element={
                  <OrderInfoTypeSwitchRoute
                    business={<BusinessOrderFlightSearchInput />}
                    customer={<CustomerOrderFlightSearchInput />}
                    maritime={<MaritimeOrderFlightSearchInput />}
                  />
                }
              />
              <Route
                path='ordergoodsanddestinationinput/:urlId'
                element={
                  <OrderInfoTypeSwitchRoute
                    business={<BusinessOrderGoodsAndDestinationInput />}
                    customer={<CustomerOrderGoodsAndDestinationInput />}
                    maritime={<MaritimeOrderGoodsAndDestinationInput />}
                  />
                }
              />
              <Route
                path='ordercontactinput/:urlId'
                element={<MaritimeOrderContactInput />}
              />
              <Route
                path='orderconfirm/:urlId'
                element={
                  <OrderInfoTypeSwitchRoute
                    business={<BusinessOrderConfirm />}
                    customer={<CustomerOrderConfirm />}
                    maritime={<MaritimeOrderConfirm />}
                  />
                }
              />
              <Route
                path='ordercomplete/:urlId'
                element={
                  <OrderInfoTypeSwitchRoute
                    business={<BusinessOrderComplete />}
                    customer={<CustomerOrderComplete />}
                    maritime={<MaritimeOrderComplete />}
                  />
                }
              />
            </Route>
            <Route path='/orderview' element={<OrderView />} />
            <Route path='/orderauth' element={<OrderAuth />} />
            <Route path='/requesterview' element={<RequesterView />} />
            <Route path='/geoinformationview' element={<GeoInformationView />} />
            <Route path='/forbidden403Page' element={<Forbidden403Page />}></Route>
          </Routes>
        </ThemeProvider>
      </StyledEngineProvider>
    </BrowserRouter>
  );
}
export default App;
